import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TenantProvider } from "./contexts/TenantContext";
import { UserProvider } from "./contexts/UserContext";
import { AuthTokenProvider } from "./contexts/AuthTokenContext";
import { AvailableCollectionsProvider } from "./contexts/AvailableCollectionsContext";
import { TourProvider } from "./contexts/TourContext";

// Silence the benign ResizeObserver loop warning so CRA's dev overlay
// doesn't promote it to a fullscreen error every time the layout reflows.
const RESIZE_OBSERVER_NOISE = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
];
window.addEventListener("error", (e) => {
  if (e.message && RESIZE_OBSERVER_NOISE.some((m) => e.message.includes(m))) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e.reason?.message || String(e.reason || "");
  if (RESIZE_OBSERVER_NOISE.some((m) => msg.includes(m))) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <UserProvider>
        <AuthTokenProvider>
          <AvailableCollectionsProvider>
            <TourProvider>
              <App />
            </TourProvider>
          </AvailableCollectionsProvider>
        </AuthTokenProvider>
      </UserProvider>
    </TenantProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
